import createRoutine from '@/utils/createRoutine'

export const componentSizeRoutine = createRoutine('componentSizeRoutine')

export const geometricBackgroundGetters = {
  COMPONENT_SIZE_ROUTINE: 'COMPONENT_SIZE_ROUTINE'
}
